export default angular.module('obto.data.obtemplate', ['obto.data.service'])
    .controller('OBTemplateController', ['$scope', '$http', '$routeParams', '$log', 'pageService', '$location', '$route', '$timeout', '_', '$rootScope', '$uibModal', 'bjs', 'swal', function ($scope, $http, $routeParams, $log, pageService, $location, $route, $timeout, _, $rootScope, $uibModal, bjs, swal) {

        let schemaSize = 0;
        $scope.filterModal = {};
        $scope.schema = {
            chart : {
                name : $routeParams.name
            }
        };
        $scope.events = [];
        $scope.decode = function (val) {

            let returnThis = val.toString();
            if (!_.isUndefined(val) && returnThis.startsWith("{{") && returnThis.endsWith("}}")) {

                returnThis = returnThis.substring(2, returnThis.indexOf("}}"));
                //console.log("Val :"  + returnThis);
                return _.isUndefined($rootScope.user[returnThis]) ? val : $rootScope.user[returnThis];
            }

            return val;
        };

        let controlFunction = function () {
            return function (H, id) {
                Highcharts.Chart.prototype.callbacks.push(function (chart) {
                    H.addEvent(chart.container, 'click', function (e) {
                        e = chart.pointer.normalize();
                        //$('#' + id).html('Clicked chart at ' + e.chartX + ', ' + e.chartY);
                        console.log('Clicked chart at ' + e.chartX + ', ' + e.chartY);
                    });
                    H.addEvent(chart.xAxis[0], 'afterSetExtremes', function (e) {
                        //$('#' + id).html('Set extremes to ' + e.min.toFixed(2) + ', ' + e.max.toFixed(2));
                    });
                });
            };
        };

        $scope.chartConfigs = [];

        $scope.chartTitle = "";

        $scope.isChart = function (val) {
            return !!val;
        };

        $scope.getUrl = function (name) {
            return "/o/template.bto?name=" + name;
        };

        $scope.$watch("chartTitle", function (n, o) {
            //console.log(n);
        }, true);

        $scope.reflow = function () {
            $scope.$broadcast('highchartsng.reflow');
        };

        $scope.getRows = function (n) {

            return new Array(parseInt(n));
        };

        if (!_.isUndefined($routeParams.thisIsLast)) {
            delete $routeParams.thisIsLast;
        }

        let fetchData = function (chartConfig) {
            //console.log(data.series.length);
            let series = [];
            _.each(chartConfig.series, function (val) {

                pageService.getbydata(val, function (_data) {

                    //series.push({"name": val, "data": _data});// = _data;
                    series.push(_data);

                }, $.param($routeParams));

            });
            //console.log(series);
            //let cat = ["ChangeView", "ChangeListView", "HomepageMyITIL", "IncidentView", "IncidentListView", "KnowledgeArticleView", "KnowledgeView", "LivefeedView", "ProblemListView", "ProblemView", "Textsearch2"];
            if (!_.isUndefined($scope.rowSchema[chartConfig.outerKey].widgets[chartConfig.innerKey].chart.chartConfig.xAxis)) {
                $scope.chartConfigs[chartConfig.outerKey][chartConfig.innerKey].xAxis.categories = [];
                //$scope.rowSchema[chartConfig.outerKey].widgets[chartConfig.innerKey].chart.chartConfig.xAxis.categories = []
            }

            $scope.chartConfigs[chartConfig.outerKey][chartConfig.innerKey].series = series;
            //$scope.rowSchema[chartConfig.outerKey].widgets[chartConfig.innerKey].chart.chartConfig.series = series;
        };

        $scope.$on('setdata', function (event, data) {
            //console.log(data); // 'Data to send'
            $timeout(function () {
                fetchData(data);
            }, 1000);

        });

        $scope.getColumns = function (n) {
            try {
                if (n)
                    return new Array(parseInt(n));
            } catch (e) {
                console.log("Please refersh the page : " + e);
            }

        };

        $scope.$watch("rowSchema", function (newValue, oldValue) {

            if (!_.isUndefined($scope.rowSchema))
                angular.forEach($scope.rowSchema, function (value, key) {

                    angular.forEach(value.widgets, function (_value, _key) {
                        let _chartConfig = _value.chart.chartConfig;

                        if (typeof _chartConfig !== "object" && !_.isUndefined(_chartConfig))
                            pageService.getbyid(_value.chart.chartConfig, function (data) {


                                try {
                                    //console.log(JSON.stringify(data.rows[0].script));
                                    let config = JSON.parse(data.rows[0].script);//JSON.parse(data.rows[0].script);//JSON.parse(
                                    //console.log("config:" + JSON.stringify(config.options.plotOptions.series.point))
                                    config.options.plotOptions.series.point.events.click = new Function(config.options.plotOptions.series.point.events.click);

                                    let id = data.rows[0]._id;
                                    //console.log()

                                    let _b = {
                                        outerKey: key,
                                        innerKey: _key,
                                        _id: id,
                                        series: config.series
                                    };

                                    if (config.series instanceof Array)
                                        if (typeof config.series[0] === 'string') {
                                            $scope.$broadcast("setdata", _b);
                                            config.series = "";

                                        }

                                    controlFunction()(Highcharts, id);
                                    $scope.chartConfigs[key][_key] = config;
                                    //$scope.rowSchema[key].widgets[_key].chart.chartConfig = config;

                                } catch (e) {
                                    console.error(e);
                                }


                            });
                    });

                });

        });

    }])
    .filter('scheduleFilter', function () {
        return function (items, day, period) {

            if (!_.isUndefined(items) && items.length !== 0) {

                let filtered = [];
                let found = false;

                angular.forEach(items, function (e) {

                    if (e.day === day && e.period === period) {
                        console.log("parentApp" + day + ": " + period);

                        found = true;
                        //console.log("parentApp" + parentApp);
                        filtered.push(e);
                    }

                });

                if (!found) {
                    filtered.push({
                        subject: {
                            label: ""
                        },
                        class: {
                            label: ""
                        }
                    });
                }
                return filtered;
            }
        };
    })
    .directive('obtoTemplateTest', function ($rootScope, $compile, $http, $window, $templateCache, $timeout, moment, _, $routeParams, bjs, $anchorScroll, $location, $uibModal, API, async, $localstorage, $templateRequest) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                name: '@'
            },
            transclude: true,
            controller: function () {


            },
            //template: '<ng-include src="template" onload="replace()"></ng-include>',
            link: function (scope, element, attrs) {
                let templateLoader, baseURL = "/o/template.bto?name=";
                let tplURL = "";
                let templateName = scope.name;
                let o = {
                    root: $rootScope,
                    scope: scope,
                    timeout: $timeout,
                    http: $http,
                    window: $window,
                    moment: moment,
                    _: _,
                    routeParams: $routeParams,
                    async: async,
                    beautify: bjs,
                    scrollTo: $anchorScroll,
                    location: $location,
                    modal: $uibModal,
                    API: API,
                    localStorage: $localstorage,
                    swal:swal
                };
                let fetch = false;

                let executeThis = function () {
                    if (fetch) {
                        templateLoader = $http.get(tplURL, {cache: $templateCache});
                        // console.log(tplURL);
                        templateLoader.then(function (response) {
                            // console.log("Loading from server..." + templateName);
                            // console.log(response.data);
                            element.html(response.data.html);
                            element.html($compile(element.html())(scope));
                            angular.forEach(response.data.loadscripts, function (value, key) {
                                $localstorage.set("ts-" + templateName, value.script);
                                // new Function("try { " + value.script + "} catch(err){ console.log(err)}")()(o);
                                try {
                                    new Function("try { " + value.script + "} catch(err){ console.log(err)}")()(o);//new Function(value.script)()(o);
                                } catch (e) {
                                    console.log(e);
                                }
                            });
                            $localstorage.setObject("template-" + templateName, response.data);
                            // console.log("Saving to local storage...");
                        });
                    } else {
                        // console.log("Loading from cache..." + templateName);
                        try{
                            new Function($localstorage.get("ts-" + templateName))()(o);
                        } catch(e){
                            console.log(e);
                        }
                        element.html($localstorage.getObject("template-" + templateName).html);
                        element.html($compile(element.html())(scope));
                    }
                };

                tplURL = baseURL + templateName + "&v=" + $rootScope.oversion;
                templateName = scope.name;
                $http.get('/templateversion.bto?name=' + templateName).then(function (response) {
                    "use strict";
                    // console.log(response.data.version);
                    // console.log("Checking localstorage..." + templateName);
                    tplURL = baseURL + templateName + "&v=" + response.data.version;
                    let existing = $localstorage.getObject("template-" + templateName);
                    // console.log(existing);
                    if (!existing.version  || existing.version !== response.data.version) {
                        fetch = !fetch;
                    }
                    // console.log(fetch);
                    executeThis(fetch);

                });
            }
        };
    });
